module.exports = __webpack_public_path__ + "img/M.d04571c0.jpg";